import React, {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {defaultTheme} from '@stencil/build-theme';

import {categoryTypes} from '@stencil/hotels-config/src/constants/details';
import {showVideoDwebSelector} from '@stencil/hotels-cg-reducer/src/details/selectors';

import HappyAngleRightIcon from '@stencil/icons/src/HappyAngleRightIcon/HappyAngleRightIcon';

import {FlexCentered} from '../../../../CommonStyleUtils/dwebCommon.styles';

import * as S from './CaptivateAllImageModal.styles';

interface CaptivateAllImageHeaderProps {
  gridType?: number;
  headerType?: string;
  title?: string;
  totalCount?: number;
  onCategorySelection?: (id: string, allVideos?: boolean) => void;
  updateMediaDetails?: (type: string, selectedId: string) => void;
}

const CaptivateAllImageHeader: React.FC<CaptivateAllImageHeaderProps> = ({
  gridType = 0,
  headerType = '',
  title = '',
  totalCount = 0,
  onCategorySelection = () => {},
  updateMediaDetails = () => {},
}) => {
  const showDwebVideos = useSelector(showVideoDwebSelector);

  const handleCategorySelection = useCallback(
    (e: React.MouseEvent) => {
      e.preventDefault();
      onCategorySelection(title);
    },
    [onCategorySelection, title],
  );

  const handleUpdateMediaDetails = useCallback(() => {
    updateMediaDetails(categoryTypes.allMedia, '');
  }, [updateMediaDetails]);

  const remainingCount = totalCount - gridType;

  const renderViewMore = useCallback(() => {
    if (remainingCount <= 0) return null;

    if (showDwebVideos) {
      return (
        <S.CaptivateViewMore onClick={handleCategorySelection}>
          View {remainingCount} more
        </S.CaptivateViewMore>
      );
    }

    return (
      <S.ViewMorePills onClick={handleCategorySelection}>
        + {remainingCount} more
        <HappyAngleRightIcon
          width="1rem"
          height="1rem"
          fill={defaultTheme.colors.goWhite.base}
          margin="0 0 0 1rem"
        />
      </S.ViewMorePills>
    );
  }, [remainingCount, showDwebVideos, handleCategorySelection]);

  return (
    <>
      {headerType === 'taggedMedia' ? (
        <S.CaptivateTaggedHeaderWrap>
          <FlexCentered>
            <S.RoundCircleWrapSpan onClick={handleUpdateMediaDetails}>
              <S.LeftArrowGalleryTraveller />
            </S.RoundCircleWrapSpan>
            <S.CaptivateHeaderText>
              {title} ({totalCount})
            </S.CaptivateHeaderText>
          </FlexCentered>
        </S.CaptivateTaggedHeaderWrap>
      ) : (
        <S.CaptivateHeaderWrap>
          <FlexCentered>
            <S.CaptivateHeaderText>
              {title} ({totalCount})
            </S.CaptivateHeaderText>
          </FlexCentered>
          {renderViewMore()}
        </S.CaptivateHeaderWrap>
      )}
    </>
  );
};

export default CaptivateAllImageHeader;
